"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
const useSelectedOption = () => {
  const [selectedOption, setSelectedOption] = (0, _react.useState)();
  const ref = (0, _react.useCallback)(node => {
    if (node !== null && selectedOption?.value !== node.selectedOption?.value) {
      setSelectedOption(node.selectedOption);
    }
  }, [selectedOption]);
  return [ref, selectedOption];
};
var _default = exports.default = useSelectedOption;